<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_location_departments') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Location Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="name">Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="name" type="text" class="form-control" id="name" placeholder="Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{nameError}}</font>
                                </div>
                            </div>

                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Upload Logo :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <!--<div class="requiredstar">*</div>-->
                                    <font class="text-danger">{{imageError}}</font>
                                    <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addCompanyBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addCompany()">
                                    <input id="addAndContinueCompanyBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addCompany(flag='Save and Continue')">
                                    <input id="cancelCompany" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import vue2Dropzone from 'vue2-dropzone';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'AddLocation',
        pageTitle: 'Add Company',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                //V-model
                userPermissions: ['add_location_departments'],
                name: '',
                isFileUploaded: false,
                imageURL: '',
                imageType: [],
                imageSize: [],
                imagePath: [],
                imageWidth: 0,
                imageHeight: 0,
                imageError: '',
                
                //Errors
                nameError: '',
                companyIdError: '',
                locationTypeError: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.pageTitle = 'Add Company';
        },
        mounted: function () {
            self.showLoader();
            /*self.loadUsers();*/
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatecompany') {
                if (segments[3]) {
                    self.pageTitle = 'Edit Company';
                    self.loadCompany();
                    $("#addAndContinueCompanyBtn").hide();
                    $("#addCompanyBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            } else {
                self.hideLoader();
            }
            
            $("#name").on('keyup', function () {
                self.nameError = '';
            });
            $("#alertError").hide();
            self.getPermissions();
        },
        watch: {
            
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/companylist');
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            removedSelectedFile(file) {
                //console.log(file);
                var isManuallyAdded = (file.manuallyAdded === null || typeof (file.manuallyAdded) === "undefined" || file.manuallyAdded == '') ? false : file.manuallyAdded;
                //console.log(isManuallyAdded);
                // return false;
                // , xhr, error
                // alert(self.imagePath.length);
                /* self.imagePath = [];
                self.imageSize = [];
                self.imageType = []; */
                if (self.imagePath.length <= 0) {    
                    self.isFileUploaded = false;
                }
                
                if(!isManuallyAdded) {
                    var filePath = JSON.parse(file.xhr.response);
                    // console.log(filePath);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                    for (var i = self.imagePath.length - 1; i >= 0; i--) {
                        if (self.imagePath[i] === filePath.content.media_path) {
                            
                            self.imagePath.splice(i, 1);
                            self.imageType.splice(i, 1);
                            self.imageSize.splice(i, 1);
                            self.imageHeight = 0;
                            self.imageWidth = 0;
                        }
                    }
                } else {
                    self.imagePath = [];
                    self.imageSize = [];
                    self.imageType = [];
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                self.imagePath.push(response.content.media_path);
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType.push(file.type);
                self.imageSize.push(file.size);
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
                /* if (self.isFileUploaded == true && self.imageHeight % 225 != 0 || !(self.imageHeight >= 225) || !(self.imageHeight <= 450)
                        || self.imageWidth % 600 != 0 || !(self.imageWidth >= 600) || !(self.imageWidth <= 1200)) {
                    self.removeAllFiles();
                    self.imageError = "Please Upload Image In This Dimensions Only.(Height : 450 pixel, Width 1200 pixel)";
                } */
                // alert(self.imagePath.length);
                /* if(self.imagePath.length > 1) {
                    self.removedSelectedFile(file, 'undefined', 'undefined');
                } */
            },

            checkForm: function () {
                var checked = true;
                /* var status = document.getElementById("status");
                var type = document.getElementById("type"); */

                // var typ = (self.type === null || typeof self.type.value === "undefined" || self.type.value === null || self.type.value == '') ? '' : self.type.value;
                // var recuTyp = (self.recursiveType === null || typeof self.recursiveType.value === "undefined" || self.recursiveType.value === null || self.recursiveType.value == '') ? '' : self.recursiveType.value;
                
                self.nameError = "";
                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (self.isFileUploaded == true && self.imageHeight % 225 != 0 || !(self.imageHeight >= 225) || !(self.imageHeight <= 450)
                        || self.imageWidth % 600 != 0 || !(self.imageWidth >= 600) || !(self.imageWidth <= 1200)) {
                    self.removeAllFiles();
                    self.imageError = "Please Upload Image In This Dimensions Only.(Height : 450 pixel, Width 1200 pixel)";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            loadCompany() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3]
                    }
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.get("getCompanyById", config)
                        .then(function (response) {
                            // self.locationId = response.data.content[0].location_name;
                            self.name = response.data.content.name;
                            if(response.data.content.logo && response.data.content.logo != null) {
                                self.imagePath.push(response.data.content.logo);
                                if (self.imagePath[0] != '') {
                                    self.isFileUploaded = true;
                                    self.imageSize.push(response.data.content.image_size);
                                    self.imageWidth = 1200;
                                    self.imageHeight = 450;
                                    self.uploadManually();
                                    //self.imagePath = '';
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            // alert(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addCompany(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    if (segments[2] == 'updatecompany') {
                        if (segments[3]) {
                            var data = {
                                name: self.name,
                                id: segments[3],
                                mediaPath: self.imagePath[0],
                                mediaType: self.imageType[0],
                                mediaSize: self.imageSize[0],
                            };
                            $("#addCompanyBtn").val("Updating ...");
                            $("#addCompanyBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#cancelCompany").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueCompanyBtn").val("Saving ...");
                                $("#addAndContinueCompanyBtn").prop("disabled", true);
                                $("#addCompanyBtn").prop("disabled", true);
                                $("#cancelCompany").prop("disabled", true);
                            } else {
                                $("#addCompanyBtn").val("Saving ...");
                                $("#addCompanyBtn").prop("disabled", true);
                                $("#addAndContinueCompanyBtn").prop("disabled", true);
                                $("#cancelCompany").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            name: self.name,
                            mediaPath: self.imagePath[0],
                            mediaType: self.imageType[0],
                            mediaSize: self.imageSize[0],
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueCompanyBtn").val("Saving ...");
                            $("#addAndContinueCompanyBtn").prop("disabled", true);
                            $("#addCompanyBtn").prop("disabled", true);
                            $("#cancelCompany").prop("disabled", true);
                        } else {
                            $("#addCompanyBtn").val("Saving ...");
                            $("#addCompanyBtn").prop("disabled", true);
                            $("#addAndContinueCompanyBtn").prop("disabled", true);
                            $("#cancelCompany").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatecompany", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatecompany') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addCompanyBtn").val("Update");
                                        $("#addCompanyBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#cancelCompany").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCompanyBtn").val("Save and Continue");
                                            $("#addAndContinueCompanyBtn").prop("disabled", false);
                                            $("#addCompanyBtn").prop("disabled", false);
                                            $("#cancelCompany").prop("disabled", false);
                                        } else {
                                            $("#addCompanyBtn").val("Save");
                                            $("#addCompanyBtn").prop("disabled", false);
                                            $("#addAndContinueCompanyBtn").prop("disabled", false);
                                            $("#cancelCompany").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCompanyBtn").val("Save and Continue");
                                        $("#addAndContinueCompanyBtn").prop("disabled", false);
                                        $("#addCompanyBtn").prop("disabled", false);
                                        $("#cancelCompany").prop("disabled", false);
                                    } else {
                                        $("#addCompanyBtn").val("Save");
                                        $("#addCompanyBtn").prop("disabled", false);
                                        $("#addAndContinueCompanyBtn").prop("disabled", false);
                                        $("#cancelCompany").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    /*console.log("if");*/
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        // $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.name = '';
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    /*console.log('else');*/
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatecompany') {
                                    if (segments[3]) {
                                        $("#addCompanyBtn").val("Update");
                                        $("#addCompanyBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#cancelCompany").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCompanyBtn").prop("disabled", false);
                                            $("#addAndContinueCompanyBtn").val("Save and Continue");
                                            $("#addCompanyBtn").prop("disabled", false);
                                            $("#cancelCompany").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            // $(".alert-success").toggleClass("show");
                                            self.name = '';
                                            self.removeAllFiles();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addCompanyBtn").val("Save");
                                            $("#addCompanyBtn").prop("disabled", false);
                                            $("#addAndContinueCompanyBtn").prop("disabled", true);
                                            $("#cancelCompany").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCompanyBtn").prop("disabled", false);
                                        $("#addAndContinueCompanyBtn").val("Save and Continue");
                                        $("#addCompanyBtn").prop("disabled", false);
                                        $("#cancelCompany").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        // $(".alert-success").toggleClass("show");
                                        self.name = '';
                                        self.removeAllFiles();
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addCompanyBtn").val("Save");
                                        $("#addCompanyBtn").prop("disabled", false);
                                        $("#addAndContinueCompanyBtn").prop("disabled", true);
                                        $("#cancelCompany").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },
            uploadManually(file) {
                if (self.imagePath.length > 0) {
                    var file_name = self.getFileName(self.imagePath[0]);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath[0];
                    let file_size = self.imageSize[0];
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/ManageCompany/AddCompany.vue